import { api } from '@shop/api-client'

export type SocialAccount = {
  id: string
  platform: 'FACEBOOK' | 'INSTAGRAM'
  name: string
  username: string | null
  pictureUrl: string | null
  enabled: boolean
  connected: boolean
  connectedAt: string
}

export type SocialStatus = { keyReady: boolean; configured: boolean; appId: string | null; accounts: SocialAccount[] }

export type SocialTarget = {
  id: string
  accountId: string
  platform: 'FACEBOOK' | 'INSTAGRAM'
  accountName: string
  status: 'PENDING' | 'PUBLISHED' | 'FAILED'
  permalink: string | null
  error: string | null
  attempts: number
  publishedAt: string | null
}

export type SocialPost = {
  id: string
  productId: string | null
  caption: string
  template: string
  size: string
  hasImage: boolean
  status: 'DRAFT' | 'SCHEDULED' | 'PUBLISHING' | 'DONE' | 'PARTIAL' | 'FAILED'
  createdAt: string
  targets: SocialTarget[]
  imageCount: number
  scheduledAt: string | null
}

export const platformName = { FACEBOOK: 'فيسبوك', INSTAGRAM: 'إنستغرام' } as const

export const postStatusName: Record<SocialPost['status'], string> = {
  DRAFT: 'مسوّدة',
  SCHEDULED: 'مجدول',
  PUBLISHING: 'يُنشر…',
  DONE: 'نُشر',
  PARTIAL: 'نُشر جزئيًّا',
  FAILED: 'فشل',
}

export const socialStatus = () => api<SocialStatus>('/api/v1/social/accounts')

export const socialPosts = (productId?: string) =>
  api<SocialPost[]>(`/api/v1/social/posts${productId ? `?productId=${productId}` : ''}`)

export const unschedulePost = (id: string) => api<SocialPost>(`/api/v1/social/posts/${id}/unschedule`, { method: 'POST' })

export const retryTarget = (id: string) => api<SocialPost>(`/api/v1/social/targets/${id}/retry`, { method: 'POST' })

/** صورةٌ (Blob) ⇐ data: URL — ليُرسم في التصميم بلا قيود المصدر عند التحويل إلى JPEG. */
export function toDataUrl(blob: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => resolve(String(reader.result))
    reader.onerror = () => reject(reader.error)
    reader.readAsDataURL(blob)
  })
}
